import {
  GetWorkAreaMapsDocument,
  GetWorkAreasDocument,
  UpdateWorkAreaDocument,
  UpdateWorkAreaMutation,
  UpdateWorkAreaMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateWorkArea = () => {
  const [executeMutation] = useMutation(UpdateWorkAreaDocument, {
    extractorFn: (data: UpdateWorkAreaMutation) => data.locationsMutations.updateLocationsWorkArea,
  })

  const updateWorkArea = async (variables: UpdateWorkAreaMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkAreasDocument, GetWorkAreaMapsDocument],
    })
  }

  return {
    updateWorkArea,
  }
}
